export enum Bool {
  No = 0,
  Yes = 1,
}

export enum LoadingState {
  Idle = 0,
  Loading = 1,
  Finished = 2,
  Error = 3,
}

export function getSortColumnList(allColumns: any[], sortData: any) {
  const sorted = sortData
    .map((item: any) => allColumns.find((col: any) => col.field === item))
    .filter(Boolean);

  // 找出缺失的列
  const missing = allColumns.filter(
    (col: any) => !sortData.some((item: any) => item === col.field)
  );

  // 创建a的深拷贝，避免修改原数组
  const result = JSON.parse(JSON.stringify(sorted));

  // 对b数组进行排序，确保按index从小到大处理
  const sortedB = [...missing].sort((x, y) => x.index - y.index);

  // 遍历b数组
  for (const item of sortedB) {
    // 计算目标位置：在a中找到index等于item.index + 1的元素的位置
    const targetIndex = result.findIndex((aItem: any) => aItem.index === item.index + 1);

    if (targetIndex !== -1) {
      // 找到目标位置，在目标位置前插入
      result.splice(targetIndex, 0, item);
    } else {
      // 没找到，根据item.index找到应该插入的位置
      // 找到所有index大于item.index的元素中最小的
      const largerIndices = result.filter((aItem: any) => aItem.index > item.index);
      if (largerIndices.length > 0) {
        const minLargerIndex = Math.min(...largerIndices.map((x: any) => x.index));
        const insertPosition = result.findIndex((aItem: any) => aItem.index === minLargerIndex);
        result.splice(insertPosition, 0, item);
      } else {
        // 如果所有index都小于item.index，则插入到最后
        result.push(item);
      }
    }
  }

  return result;
}